<script setup lang="ts">
defineProps<{
  knowledgeBase: PublicKBKnowledgeBase
  categories: PublicKBCategory[]
}>()

const { t } = useTranslate()
</script>

<template>
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-6">
    <div v-for="category in categories" :key="category.id">
      <InertiaLink
        :href="category.path"
        class="flex items-center gap-4 rounded-lg border border-gray-200 p-4 hover:border-gray-400"
      >
        <PublicKBCategoryIcon :icon="category.icon" :color="knowledgeBase.secondary_color" />
        <div class="flex min-w-0 flex-col gap-2">
          <div class="truncate text-lg font-medium text-gray-900">{{ category.title }}</div>
          <div class="text-sm text-gray-500">
            {{ t(".article_count", { count: category.articles.length }) }}
          </div>
        </div>
      </InertiaLink>
    </div>
  </div>
</template>

<i18n lang="yaml">
de:
  article_count:
    zero: "Keine Artikel"
    one: "1 Artikel"
    other: "%{count} Artikel"
</i18n>
